// @flow
import React from 'react';

import useApprovals from 'hooks/approval/useApprovals';

export const withApprovals = (Component) => (props) => {
  const approvals = useApprovals();
  return <Component {...approvals} {...props} />;
};
